import { Injectable } from '@angular/core';
import { ApiRequestService } from '@core/auth/api-request.service';
import { config } from '@core/interfaces/api_baseurl';
import { BehaviorSubject, of, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RequestServiceService {

  _supportType = new BehaviorSubject<any>(null);

  constructor(private _ApiRequestService: ApiRequestService) { }

  getSupportType() {
    if (this._supportType.getValue()) {
      return of(this._supportType.getValue());
    }
    return this._ApiRequestService.postData(config.ticketing.raise.support_type).pipe(switchMap((res: any) => {
      this._supportType.next(res)
      return of(res);
    }))
  }
}
